var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c("div", { attrs: { id: "Return_Bar" } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
          _vm._v("返回")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "text" } },
        [
          _c("div", { staticClass: "boxstyle" }),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Pdf" && _vm.timerTimeValue
            ? _c("div", { staticClass: "study-countdown" }, [
                _vm._v(_vm._s(_vm.timerTimeValue))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Video"
            ? _c(
                "div",
                { staticClass: "video-player-box" },
                [
                  _c("videoPlayer", {
                    ref: "videoPlayer",
                    staticClass: "video-player",
                    attrs: { options: _vm.playerOptions },
                    on: {
                      play: _vm.onPlayerPlay,
                      pause: _vm.onPause,
                      ended: _vm.onPlayerEnded
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Pdf"
            ? [_c("div", { attrs: { id: "pdf_viewer" } })]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.currency, width: "360px" },
              on: {
                "update:visible": function($event) {
                  _vm.currency = $event
                }
              }
            },
            [
              _c("div", { staticClass: "currency_img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/voiceScene/currency_img.png"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "currency_text" }, [
                _vm.knowledgestate == 1
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的学习"),
                      _c("br"),
                      _vm._v("接下来，请进行“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.nextknowledgename))
                      ]),
                      _vm._v("”的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Exam" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行一个测试")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Practice" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行下一个练习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Study" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行下一个课程的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 2
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.categoryName))
                      ]),
                      _vm._v("”的学习"),
                      _c("br"),
                      _vm._v("接下来，请进行下一个阶段的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 1
                  ? _c("div", [
                      _vm._v("你已完成" + _vm._s(_vm.categoryName) + "的学习")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("div", { staticClass: "currency_button" }, [
                    _vm.knowledgestate == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去学习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Exam"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去测试")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Study"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("继续学习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Practice"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去练习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 &&
                    _vm.tabstate == 2 &&
                    _vm.dazhiJump == false
                      ? _c(
                          "div",
                          {
                            staticClass: "otherdetermine",
                            on: { click: _vm.goindex }
                          },
                          [
                            _vm._v(
                              "\n            去报名并参加" +
                                _vm._s(_vm.nextcategoryName)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 &&
                    _vm.tabstate == 2 &&
                    _vm.dazhiJump
                      ? _c(
                          "div",
                          {
                            staticClass: "otherdetermine",
                            on: { click: _vm.goindex }
                          },
                          [_vm._v("去学习\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.tabstate == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.goindex }
                          },
                          [_vm._v("我知道了")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.nextExamCourse
            ? _c("exam-dialog", {
                attrs: {
                  id: _vm.id,
                  visible: _vm.examVisible,
                  courseId: _vm.nextCourseId,
                  tabMajorId: _vm.tabMajorId,
                  majorId: _vm.majorId,
                  type: _vm.type,
                  isListPage: false,
                  parent: _vm.parent
                },
                on: { callback: _vm.closeDialog }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("knowledge-dialog", {
        attrs: {
          show: _vm.knowledgeDialogObj.visible,
          courseId: _vm.knowledgeDialogObj.courseId,
          knowledgeId: _vm.knowledgeDialogObj.knowledgeId,
          playSecondsAt: _vm.knowledgeDialogObj.playSecondsAt
        },
        on: {
          handleChildEvent: _vm.handleChildEventMethod,
          result: _vm.knowledgeResult
        }
      }),
      _vm._v(" "),
      _c("answer-result-dialog", {
        attrs: {
          isRight: _vm.answerResultDialogObj.isRight,
          show: _vm.answerResultDialogObj.visible
        },
        on: { goonOrNot: _vm.goonOrNot }
      }),
      _vm._v(" "),
      _vm.largerVisible
        ? _c("div", { staticClass: "img-fix-bg" }, [
            _c("div", { staticClass: "larger-box" }, [
              _c("img", { attrs: { src: _vm.largerUrl } })
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-close close",
              on: {
                click: function($event) {
                  _vm.largerVisible = false
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8234984", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8234984","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/vedioDetail.vue
// module id = 1579
// module chunks = 0